import React from "react";
import LoaderUrl from "./../../assets/Loader.gif";
import "./index.scss";

const Loader = (props) => {
  const { loadingText } = props;
  return (
    <div className="loader-main-container">
      <div className="loadewrapper">
        <img src={LoaderUrl} alt="loader" />
        <p>{loadingText ? loadingText : null}</p>
      </div>
    </div>
  );
};

export default Loader;
